import React, { useState } from 'react';
import 'whatwg-fetch';
import SearchBar from '../SearchBar';
import MyNavMenu from '../navMenu';
import { MdMenu as MenuIcon } from '@react-icons/all-files/md/MdMenu';
import { createUseStyles } from '../../../../theming';
import NavActions from './components/NavActions';
import Hidden from '../../Hidden';
import ProfileDropDown from './components/ProfileDropDown';
import useDrawer from '../../../../hooks/useDrawer';
import DropDownList from '../../DropDownList';
import ResultItem from '../SearchBar/components/ResultItem';

const useStyles = createUseStyles((theme) => ({
  root: {
    display: 'flex',
    height: theme.components.TopBar.height,
    padding: '1rem',
  },
  [theme.breakpoints.up('lg')]: {
    root: {
      marginLeft: ({ fixed }) => theme.components.Drawer[fixed ? 'defaultWidth' : 'collapseWidth'],
    },
  },
  button: {
    display: 'flex',
    marginRight: '1rem',
    cursor: 'pointer',
  },
  profile: {
    marginLeft: '2rem',
  },
  leftContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  centerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  rightContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flex: 1,
  },
}));

const TopBar = ({ history, user }) => {
  const { menuType, toggleDrawer } = useDrawer();
  const classes = useStyles({ fixed: menuType === 'fixed' });
  const [searchBarRef, setSearchBarRef] = useState<HTMLElement | null>(null);
  const [isResultOpen, setIsResultOpen] = useState(false);

  const navigateTo = (link) => {
    history.push(link);
  };

  const handleRedirect = (path: string, state?: Record<string, any>) => {
    history.push(path, state);
  };

  return (
    <>
      <div className={classes.root}>
        <div className={classes.leftContainer}>
          <Hidden lgUp>
            <div className={classes.button} onClick={toggleDrawer}>
              <MenuIcon size={20} />
            </div>
          </Hidden>

          <Hidden smDown>
            <SearchBar
              ref={setSearchBarRef}
              onClick={() => setIsResultOpen(true)}
              onRedirect={handleRedirect}
              renderResults={(results, { loading, reset }) => (
                <DropDownList
                  dropdownRef={searchBarRef}
                  emptyText='Aucun resultat'
                  isOpen={isResultOpen}
                  onClose={() => setIsResultOpen(false)}
                  renderDropDownItem={(item, key) => <ResultItem item={item} key={key} onClick={reset} />}
                  list={Object.values(results).reduce((list, value) => list.concat(value), [])}
                  loading={loading}
                />
              )}
            />
          </Hidden>
        </div>

        <div className={classes.rightContainer}>
          <NavActions navigateTo={navigateTo} />
          <ProfileDropDown user={user} navigateTo={navigateTo} />
        </div>
      </div>

      <div className={classes.centerContainer}>
        <MyNavMenu />
      </div>
    </>
  );
};

export default TopBar;
